import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Start hidden, then fade in
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-10px)"
    this.element.style.transition = "opacity 300ms ease-out, transform 300ms ease-out"

    requestAnimationFrame(() => {
      this.element.style.opacity = "1"
      this.element.style.transform = "translateY(0)"
    })

    // Auto-dismiss after 4 seconds
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, 4000)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-10px)"

    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
